import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from "react";
import { BrowserSymbol } from "./browser-symbol";
import { addSpriteSymbol, useIsomorphicLayoutEffect } from "./sprite";
import { warnOnce } from "./warnOnce";
var SvgIcon = function(_param) {
    var _param_width = _param.width, width = _param_width === void 0 ? 0 : _param_width, _param_height = _param.height, height = _param_height === void 0 ? 0 : _param_height, viewBox = _param.viewBox, id = _param.id, _param_className = _param.className, className = _param_className === void 0 ? "" : _param_className, fill = _param.fill, getRootRef = _param.getRootRef, tmp = _param.style, propsStyle = tmp === void 0 ? {} : tmp, title = _param.title, children = _param.children, restProps = _object_without_properties(_param, [
        "width",
        "height",
        "viewBox",
        "id",
        "className",
        "fill",
        "getRootRef",
        "style",
        "title",
        "children"
    ]);
    var size = Math.max(width, height);
    var style = _object_spread({
        width: width,
        height: height
    }, propsStyle);
    return /*#__PURE__*/ React.createElement("svg", _object_spread_props(_object_spread({
        "aria-hidden": "true",
        display: "block"
    }, restProps), {
        className: [
            "vkuiIcon",
            "vkuiIcon--".concat(size),
            "vkuiIcon--w-".concat(width),
            "vkuiIcon--h-".concat(height),
            "vkuiIcon--".concat(id),
            className
        ].join(" ").trim(),
        viewBox: viewBox,
        width: width,
        height: height,
        style: style,
        ref: getRootRef
    }), title && /*#__PURE__*/ React.createElement("title", null, title), /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#".concat(id),
        style: {
            fill: "currentColor",
            color: fill
        }
    }, children));
};
export function makeIcon(componentName, id, viewBox, content, width, height, deprecated, replacement) {
    var mountIcon = function mountIcon() {
        if (!isMounted) {
            addSpriteSymbol(new BrowserSymbol({
                content: content
            }));
            isMounted = true;
        }
    };
    var isMounted = false;
    var warn = warnOnce(componentName);
    var Icon = function(props) {
        useIsomorphicLayoutEffect(mountIcon, []);
        if (deprecated) {
            var replacementNotice = replacement ? ". Замените на ".concat(replacement) : "";
            warn("Иконка устарела" + replacementNotice);
        }
        return /*#__PURE__*/ React.createElement(SvgIcon, _object_spread_props(_object_spread({}, props), {
            viewBox: viewBox,
            id: id,
            width: props.width !== undefined && !isNaN(props.width) ? +props.width : width,
            height: props.height !== undefined && !isNaN(props.height) ? +props.height : height
        }));
    };
    Icon.mountIcon = mountIcon;
    Icon.displayName = componentName;
    return Icon;
}

//# sourceMappingURL=SvgIcon.js.map